import { useState, useEffect } from 'react';
import { useApi, fetchApiRef } from '@backstage/core-plugin-api';
import { fetchOrgRepos } from '../services/githubService';

type GithubRepo = { name: string; full_name: string };

export function useGithubRepos(
  hasWorkflow: string | undefined,
): { repos: GithubRepo[]; loading: boolean; error: string | undefined } {
  const fetchApi = useApi(fetchApiRef);
  const [repos, setRepos] = useState<GithubRepo[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | undefined>();

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setError(undefined);
      try {
        setRepos(await fetchOrgRepos(fetchApi, hasWorkflow));
      } catch (e: any) {
        setError(e.message);
        setRepos([]);
      }
      setLoading(false);
    };

    load();
  }, [hasWorkflow, fetchApi]);

  return { repos, loading, error };
}
